import {
  AssetUtil,
  DEFAULT_SUPPORTED_IMAGE_TYPES,
  MediaHelpers,
  imageAssetMigrations,
  imageAssetProps
} from "@tldraw/editor";
import { DEFAULT_MAX_IMAGE_DIMENSION } from "../defaultExternalContentHandlers.mjs";
import { containBoxSize } from "../utils/assets/assets.mjs";
class ImageAssetUtil extends AssetUtil {
  static type = "image";
  static props = imageAssetProps;
  static migrations = imageAssetMigrations;
  options = {
    maxDimension: DEFAULT_MAX_IMAGE_DIMENSION,
    supportedMimeTypes: null
  };
  getDefaultProps() {
    return {
      w: 0,
      h: 0,
      name: "",
      isAnimated: false,
      mimeType: null,
      src: null
    };
  }
  getSupportedMimeTypes() {
    return this.options.supportedMimeTypes ?? DEFAULT_SUPPORTED_IMAGE_TYPES;
  }
  async getAssetFromFile(file, assetId) {
    const doc = this.editor.getContainerDocument();
    const size = await MediaHelpers.getImageSize(file, doc);
    const isAnimated = await MediaHelpers.isAnimated(file);
    const pixelRatio = "pixelRatio" in size && size.pixelRatio !== 1 ? size.pixelRatio : void 0;
    const assetInfo = {
      id: assetId,
      type: "image",
      typeName: "asset",
      props: {
        name: file.name,
        src: "",
        w: size.w,
        h: size.h,
        fileSize: file.size,
        mimeType: file.type,
        isAnimated,
        ...(pixelRatio ? { pixelRatio } : void 0)
      },
      meta: {}
    };
    const maxDimension = this.options.maxDimension;
    if (maxDimension && isFinite(maxDimension)) {
      const originalSize = { w: assetInfo.props.w, h: assetInfo.props.h };
      const resizedSize = containBoxSize(originalSize, { w: maxDimension, h: maxDimension });
      if (originalSize !== resizedSize && MediaHelpers.isStaticImageType(file.type)) {
        assetInfo.props.w = resizedSize.w;
        assetInfo.props.h = resizedSize.h;
      }
    }
    return assetInfo;
  }
}
export {
  ImageAssetUtil
};
//# sourceMappingURL=ImageAssetUtil.mjs.map
